import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Flex, MotionComponent, NumberField, ToggleField, Typography } from '@qapline/ui';

import { useVehicleFeatureOptions, useVehicleTypeOptions } from '../../../customer/vehicle';

export const VehiclePreferencesSection = () => {
    const { t } = useTranslation('common', { keyPrefix: 'entities.vehicle.preferences' });
    const { t: tCommon } = useTranslation('common');

    const featureOptions = useVehicleFeatureOptions();
    const typeOptions = useVehicleTypeOptions();

    return (
        <MotionComponent component={Card} layout gap={20}>
            <Typography variant="h5">{t('title')}</Typography>
            <Flex direction="column" gap={3}>
                <Flex justify="between">
                    <Flex direction="column" gap={3}>
                        <Typography>{t('typesDescription')}</Typography>
                        <Flex gap={2} wrap>
                            {typeOptions.map(({ label, value }) => (
                                <Flex key={value}>
                                    <ToggleField
                                        name={`vehicleTypes.${value - 1}.selected`}
                                        key={value}
                                        value={value.toString()}
                                    >
                                        {label}
                                    </ToggleField>
                                </Flex>
                            ))}
                        </Flex>
                    </Flex>
                    <Flex gap={4}>
                        <NumberField
                            name="minLoadingMeters"
                            label={t('minLoadingMeters')}
                            suffix={<Typography color="secondary">{tCommon('units.meter')}</Typography>}
                        />
                        <NumberField
                            name="minLoadingWeight"
                            label={t('minLoadingWeight')}
                            suffix={<Typography color="secondary">{tCommon('units.ton')}</Typography>}
                        />
                    </Flex>
                </Flex>
            </Flex>
            <Flex direction="column" gap={3}>
                <Typography>{t('featuresDescription')}</Typography>
                <Flex gap={2} wrap>
                    {featureOptions.map(({ label, value }) => (
                        <Flex key={value}>
                            <ToggleField
                                name={`vehicleFeatures.${value - 1}.selected`}
                                key={value}
                                value={value.toString()}
                            >
                                {label}
                            </ToggleField>
                        </Flex>
                    ))}
                </Flex>
            </Flex>
        </MotionComponent>
    );
};
